import resourceTypes, { ResourceTypes } from './resourceTypes';

// Human-readable labels for resource types, matching the names used elsewhere in the UI
// (nav menu, breadcrumbs, access management tabs) for the same resources.
const resourceTypeLabels: Record<ResourceTypes, string> = {
  [resourceTypes.ACCOUNT]: 'Account settings',
  [resourceTypes.ACCOUNT_ENTITY]: 'Accounts',
  [resourceTypes.ANALYSIS]: 'Analyses',
  [resourceTypes.API_KEY]: 'API keys',
  [resourceTypes.BUSINESS]: 'Businesses',
  [resourceTypes.CAR]: 'Cars',
  [resourceTypes.CASE_TRANSACTION_SNAPSHOT]: 'Transaction snapshots',
  [resourceTypes.CASE]: 'Cases',
  [resourceTypes.CONNECTION]: 'Connections',
  [resourceTypes.DATA_POINT]: 'Data points',
  [resourceTypes.FORM]: 'Forms',
  [resourceTypes.GROUP]: 'Groups',
  [resourceTypes.INDIVIDUAL]: 'Individuals',
  [resourceTypes.KYCFORM]: 'KYC forms',
  [resourceTypes.MEMBER]: 'Members',
  [resourceTypes.PERMISSION_ROLE]: 'Permission roles',
  [resourceTypes.PING]: 'Pings',
  [resourceTypes.PROCESS]: 'Processes',
  [resourceTypes.PRODUCT]: 'Products',
  [resourceTypes.REPORT]: 'Reports',
  [resourceTypes.REVIEW]: 'Reviews',
  [resourceTypes.REQUEST]: 'Requests',
  [resourceTypes.RISK_CLASS]: 'Risk classes',
  [resourceTypes.RULE]: 'Rules',
  [resourceTypes.RULE_VERSION]: 'Rule versions',
  [resourceTypes.SERVICE]: 'Services',
  [resourceTypes.SIGNAL]: 'Signals',
  [resourceTypes.TAG]: 'Tags',
  [resourceTypes.TEAM]: 'Teams',
  [resourceTypes.TRANSACTION_TYPE]: 'Transaction types',
  [resourceTypes.TRANSACTION_TABLE_SETUP]: 'Interface settings',
};

export default resourceTypeLabels;
